"use strict";

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = require("react");

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var _default = function _default(initialFormFieldsData) {
  var _useState = (0, _react.useState)(initialFormFieldsData),
      formFields = _useState[0],
      setFormFields = _useState[1];

  var _useState2 = (0, _react.useState)(false),
      shouldValidate = _useState2[0],
      setShouldValidate = _useState2[1];

  var setFormFieldValue = function setFormFieldValue(fieldKey, value) {
    var _extends2;

    if (value === void 0) {
      value = null;
    }

    var error = formFields[fieldKey].error || null;
    var validator = formFields[fieldKey].validator || null;

    if (shouldValidate && validator) {
      var validationResult = validator(value, formFields);

      if (validationResult.isValid) {
        error = null;
      } else if (validationResult.error) {
        error = validationResult.error;
      }
    }

    setFormFields(_extends({}, formFields, (_extends2 = {}, _extends2[fieldKey] = _extends({}, formFields[fieldKey], {
      value: value,
      error: error
    }), _extends2)));
  };

  var startValidating = function startValidating() {
    setShouldValidate(true);
  };

  var validateForm = function validateForm() {
    startValidating();
    var updatedFormFields = formFields;
    var formFieldKeys = Object.keys(updatedFormFields);
    formFieldKeys.forEach(function (fieldKey) {
      var formField = updatedFormFields[fieldKey];
      var _formField$value = formField.value,
          value = _formField$value === void 0 ? null : _formField$value,
          validator = formField.validator;

      if (validator) {
        var validationResult = validator(value, updatedFormFields);

        if (validationResult.isValid) {
          updatedFormFields[fieldKey] = _extends({}, formField, {
            error: null
          });
        }

        if (validationResult.error) {
          updatedFormFields[fieldKey] = _extends({}, formField, {
            error: validationResult.error
          });
        }
      }
    });
    setFormFields(updatedFormFields);
    return formFieldKeys.every(function (fieldKey) {
      return !updatedFormFields[fieldKey].error;
    });
  };

  var getFormField = function getFormField(fieldKey) {
    return formFields && formFields[fieldKey] && formFields[fieldKey] || null;
  };

  var getFormFieldValue = function getFormFieldValue(fieldKey) {
    return getFormField(fieldKey) && getFormField(fieldKey).value || null;
  };

  var getFormFieldError = function getFormFieldError(fieldKey) {
    return getFormField(fieldKey) && getFormField(fieldKey).error || null;
  };

  return {
    setFormFieldValue: setFormFieldValue,
    validateForm: validateForm,
    formFields: formFields,
    getFormField: getFormField,
    getFormFieldValue: getFormFieldValue,
    getFormFieldError: getFormFieldError
  };
};

exports["default"] = _default;
module.exports = exports["default"];